<template>
  <div>
    <v-data-table
      v-bind="this.$attrs"
      item-key="id"
      loading-text="Đang Tải"
      no-data-text="Không có dữ liệu"
      :options.sync="tableOptions"
      :server-items-length="studentCount"
      :headers="headers"
      :items="mealReports"
      :loading="loading"
      :footer-props="footerOptions"
      disable-sort
    >
      <template v-slot:[`item.dob`]="{ item }">
        {{ item.student.dob | ddmmyyyy }}
      </template>
      <template v-slot:[`item.class`]="{ item }">
        <router-link style="text-decoration: none" :to="'/class/' + $_get(item, 'student.currentClass.id')">
          <span>{{ $_get(item, 'student.currentClass.title') }}</span>
        </router-link>
      </template>
      <template v-slot:[`item.student`]="{ item }">
        <CardStudentName :student="item.student" link />
      </template>
      <template v-slot:[`item.selectedMenu`]="{ item }">
        <div>{{ $_get(item, 'studentMenu.selectedMenu') | selectedMenu }}</div>
      </template>
      <template v-slot:[`item.mealTransferStatus`]="{ item }">
        <div>{{ $_get(item, 'mealTransferStatus') | mealTransferStatus }}</div>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-hover v-slot="{ hover }">
          <v-icon :color="hover ? 'primary' : ''" @click="() => onDetail(item)">mdi-eye</v-icon>
        </v-hover>
      </template>
    </v-data-table>
    <MealReportDetailDialog ref="meal-detail-report-dialog" />
  </div>
</template>
<script>
import { get } from 'lodash'
import { mapActions, mapState } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import MealReportDetailDialog from './MealReportDetailDialog.vue'

const originHeaders = [
  { text: 'Học sinh', value: 'student' },
  { text: 'Lớp', value: 'class' },
  { text: 'Ngày sinh', value: 'dob' },
  { text: 'Thực đơn 1', value: 'menu1Count' },
  { text: 'Thực đơn 2', value: 'menu2Count' },
  { text: 'Tổng suất đã đăng ký', value: 'totalCount' },
  { text: 'Tổng suất ăn thực tế', value: 'mealAteLength' },
  { text: 'Tổng suất hủy hợp lệ', value: 'validCancelLength' },
  { text: 'Tổng suất ăn tính tiền', value: 'totalAmountGetMoney' },
  { text: 'Thao tác', value: 'actions' }
]

export default {
  components: { CardStudentName, MealReportDetailDialog },
  data: () => ({
    headers: originHeaders,
    tableOptions: {},
    reportDate: null // Dữ liệu ngày lấy report, tháng của report sẽ phụ thuộc vào tháng và năm trong biến date này
  }),
  methods: {
    ...mapActions({ onPageChange: 'MealReport/requestPageSettings', onSearch: 'MealReport/searchStudentMealReports' }),
    /**
     * Hàm chạy khi filter data thay đổi
     */
    async refresh(query) {
      query = query || {}
      this.reportDate = get(query, 'date', '')
      await this.onSearch(query)
    },
    onDetail(item) {
      const { student } = item
      this.$refs['meal-detail-report-dialog'].openDialog(student, this.reportDate)
    }
  },
  computed: {
    ...mapState('MealReport', ['studentCount', 'mealReports', 'loading']),
    footerOptions() {
      let footer = {
        'items-per-page-text': 'Số học sinh mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
    pageText() {
      const page = this.tableOptions.page
      const itemsPerPage = this.tableOptions.itemsPerPage
      const pageStart = (page - 1) * itemsPerPage + 1
      let pageStop = page * itemsPerPage
      pageStop = pageStop > this.studentCount || pageStop === -1 ? this.studentCount : pageStop
      return `${pageStart}-${pageStop} trên ${this.studentCount}`
    }
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged)
          this.onPageChange({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
      },
      deep: true
    }
  }
}
</script>
